var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import { arrayOf, func, string } from 'prop-types';
import WixComponent from '../BaseComponents/WixComponent';
import s from './ButtonSelection.scss';

var ButtonSelection = function (_WixComponent) {
  _inherits(ButtonSelection, _WixComponent);

  function ButtonSelection() {
    _classCallCheck(this, ButtonSelection);

    return _possibleConstructorReturn(this, (ButtonSelection.__proto__ || Object.getPrototypeOf(ButtonSelection)).apply(this, arguments));
  }

  _createClass(ButtonSelection, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          value = _props.value,
          buttonsNames = _props.buttonsNames;

      if (value && buttonsNames.every(function (b) {
        return b !== value;
      })) {
        throw new Error('ButtonSelection: Invalid button selected');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          value = _props2.value,
          buttonsNames = _props2.buttonsNames,
          onChange = _props2.onChange;

      return React.createElement(
        'div',
        { className: s.buttonsComplex },
        buttonsNames.map(function (buttonName) {
          return React.createElement(
            'span',
            {
              key: buttonName,
              className: value === buttonName ? s.selected : s.unselected,
              onClick: function onClick() {
                if (buttonName !== value) {
                  onChange(buttonName);
                }
              }
            },
            buttonName
          );
        })
      );
    }
  }]);

  return ButtonSelection;
}(WixComponent);

ButtonSelection.propTypes = {
  buttonsNames: arrayOf(string.isRequired).isRequired,
  value: string,
  onChange: func.isRequired
};


ButtonSelection.displayName = 'ButtonSelection';

export default ButtonSelection;
//# sourceMappingURL=ButtonSelection.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/ButtonSelection/ButtonSelection.js